"use client";
'use strict';

var React = require('react');

/**
 * React hook for send GA events
 *
 * @example
 * ``` javascript
 * const { pushEvent } = useAnalytics()
 *
 * pushEvent({
 *    event: 'adEvent',
 *    eventCategory: 'Прочее',
 *    eventAction: 'Переход из меню',
 *    eventLabel: `${label}|ЛК`,
 * })
 * ```
 */
function useAnalytics() {
    const pushEvent = React.useCallback((payload) => {
        // @ts-ignore
        window.sravniDataLayer.push(payload);
    }, []);
    React.useEffect(() => {
        // @ts-ignore
        window.sravniDataLayer = window.sravniDataLayer || [];
    }, []);
    return { pushEvent };
}

exports.useAnalytics = useAnalytics;
//# sourceMappingURL=useAnalytics.js.map
